import { render, staticRenderFns } from "./bindBatteryDialog.vue?vue&type=template&id=5d4bf3b2&scoped=true&"
import script from "./bindBatteryDialog.vue?vue&type=script&lang=js&"
export * from "./bindBatteryDialog.vue?vue&type=script&lang=js&"
import style0 from "./bindBatteryDialog.vue?vue&type=style&index=0&id=5d4bf3b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4bf3b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d4bf3b2')) {
      api.createRecord('5d4bf3b2', component.options)
    } else {
      api.reload('5d4bf3b2', component.options)
    }
    module.hot.accept("./bindBatteryDialog.vue?vue&type=template&id=5d4bf3b2&scoped=true&", function () {
      api.rerender('5d4bf3b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/iotOrder/userRent/dialog/bindBatteryDialog.vue"
export default component.exports